import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CredfinFavicon from '../images/credfinfav.jpeg'
import AbhicashFavicon from '../images/AbhicashFav.png'
import MicromoneyFavicon from '../images/micromoneyFav.png'
import CredfinLogo from '../images/credfinlogo.png'
import MicromoneyLogo from '../images/MicromoneyLogo.png'
import AbhicashLogo from '../images/AbhicashLogo.png'
import CredfinLightLogo from '../images/credfin.png'
import creditJarLogoDark from '../images/creditJarLogo.svg'
import creditjarFavicon from '../images/creditjarFavicon.svg'

import cashbridgeLogoWhite from '../images/cashbridgeLogoWhite.svg'
import cashbridgeFavicon2 from '../images/cashbridgeFavicon2.svg'
import CashtapLogo from '../images/CashtapLogo.svg'
import cashtapFavIcon from '../images/cashtapFavIcon.svg'
import LarkFavIcon from '../images/larkFavIcon.svg'
import larklogo from '../images/larklogo.svg'
import lightlarklogo from '../images/lightlarklogo.svg'

const TENANT_CONFIGS = {
  'admin.credfin.money': {
    COMPANY_NAME: "Credfin",
    COMPANY_NAME_CAPS: "CREDFIN",
    COMPANY_NAME_SMALLCASE: "credfin",
    BASE_URL: 'https://backend.credfin.money/',
    FRONTEND_BASE_URL: 'https://admin.credfin.money/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cf',
    ESIGN_KEY: "arhamfinance&investmentservicesltd_esign_live",
    WEB_URL: 'https://admin.credfin.money/',
    TITLE: "Loans made Easy",
    FAVICON: CredfinFavicon,
    LOGO: CredfinLogo,
    LIGHT_LOGO: CredfinLightLogo,
    HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "credfin-css",
    BOSS_EMAILID: "mohit.bansal@credfin.money",
    NBFC_NAME_TO_SHOW: "Arham",
    REPORT_DB_KEY: "credfin",
    ADMIN_URL_STRING_SHORT :"credfin.money",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.credfin.money",
    NBFC_SHORT:"Arham",
    WEBSITE_URL:"https://credfin.money",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Arham Finance and Investment Services Ltd',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : 112, DAYANAND ROAD, DARYAGANJ, NEW DELHI-11,NEWDELHI,110002',
      ACCOUNT_NUMBER: 'A/C : 033305006690',
      IFSC_CODE: 'ifsc code : ICIC0000333',
      NBFC_NAME:"Arham Finance and Investment Services Ltd",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.credfin.money/uploadDocuments/",
      MOBILE_NO: "+91-9311226661",
      EMAIL_ID: "recovery@credfin.money",
      FINANCE_MAIL_ID: "finance@credfin.money",
      SUPPORT_MAIL_ID: "support@credfin.money",
      KYC_URL: 'https://admin.crefin.money/kyc/',
      CONFIG_MAIL_ID: "config@credfin.money",
      RECOVERY_MAIL_ID:"recovery@credfin.money",
      APP_LINK:"app.credfin.money/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Credfin Infotech Pvt. Ltd.",
      ADDRESS:"1401,1403, Building No. 43, Chiranjiv Tower",
      AREA:"Opposite Eros Hotel, Nehru Place",
      CITY :"New Delhi- 110019."
    }

  },
  'admin.micromoney.in': {
    COMPANY_NAME: "Micromoney",
    COMPANY_NAME_CAPS: "MICROMONEY",
    COMPANY_NAME_SMALLCASE: "micromoney",
    BASE_URL: 'https://backend.micromoney.in/',
    FRONTEND_BASE_URL: 'https://admin.micromoney.in/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'mm',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.micromoney.in/',
    TITLE: "Small Loans Big Impact",
    FAVICON: MicromoneyFavicon,
    LOGO: MicromoneyLogo,
    LIGHT_LOGO: MicromoneyLogo,
     HEADER_LOGO_WIDTH: "60px",
    RootcssClassName: "Micromoney-css",
    BOSS_EMAILID: "mohit.bansal@micromoney.in",
    NBFC_NAME_TO_SHOW: "Yashik",
    REPORT_DB_KEY: "micromoney",
    ADMIN_URL_STRING_SHORT :"micromoney.in",
     ADMIN_URL_STRING_SHORT_FULL_URL :"admin.micromoney.in",
     NBFC_SHORT:"Yashik",
      WEBSITE_URL:"https://micromoney.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : YASHIK FINLEASE PRIVATE LIMITED.',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : Gurgaon Emaar Palm Square',
      ACCOUNT_NUMBER: 'A/C : 555905000039',
      IFSC_CODE: 'ifsc code : ICIC0005559',
       NBFC_NAME:"YASHIK FINLEASE PRIVATE LIMITED.",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.micromoney.in/uploadDocuments/",
      MOBILE_NO: "+91-9773899027",
      EMAIL_ID: "recovery@micromoney.in",
      FINANCE_MAIL_ID: "finance@micromoney.in",
       SUPPORT_MAIL_ID: "support@micromoney.in",
      KYC_URL: 'https://admin.micromoney.in/kyc/',
      CONFIG_MAIL_ID: "config@micromoney.in",
      RECOVERY_MAIL_ID:"recovery@micromoney.in",
      APP_LINK:"app.micromoney.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Micromoney Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  },
  'adminu.micromoney.in': {
    COMPANY_NAME: "Micromoney",
    COMPANY_NAME_CAPS: "MICROMONEY",
    COMPANY_NAME_SMALLCASE: "micromoney",
    BASE_URL: 'https://backend.micromoney.in/',
    FRONTEND_BASE_URL: 'https://admin.micromoney.in/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'mm',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.micromoney.in/',
    TITLE: "Small Loans Big Impact",
    FAVICON: MicromoneyFavicon,
    LOGO: MicromoneyLogo,
    LIGHT_LOGO: MicromoneyLogo,
     HEADER_LOGO_WIDTH: "60px",
    RootcssClassName: "Micromoney-css",
    BOSS_EMAILID: "mohit.bansal@micromoney.in",
    NBFC_NAME_TO_SHOW: "Yashik",
    REPORT_DB_KEY: "micromoney",
    ADMIN_URL_STRING_SHORT :"micromoney.in",
     ADMIN_URL_STRING_SHORT_FULL_URL :"admin.micromoney.in",
     NBFC_SHORT:"Yashik",
      WEBSITE_URL:"https://micromoney.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : YASHIK FINLEASE PRIVATE LIMITED.',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : Gurgaon Emaar Palm Square',
      ACCOUNT_NUMBER: 'A/C : 555905000039',
      IFSC_CODE: 'ifsc code : ICIC0005559',
       NBFC_NAME:"YASHIK FINLEASE PRIVATE LIMITED.",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.micromoney.in/uploadDocuments/",
      MOBILE_NO: "+91-9773899027",
      EMAIL_ID: "recovery@micromoney.in",
      FINANCE_MAIL_ID: "finance@micromoney.in",
       SUPPORT_MAIL_ID: "support@micromoney.in",
      KYC_URL: 'https://admin.micromoney.in/kyc/',
      CONFIG_MAIL_ID: "config@micromoney.in",
      RECOVERY_MAIL_ID:"recovery@micromoney.in",
      APP_LINK:"app.micromoney.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Micromoney Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  },
  'admin.abhicash.in': {
    COMPANY_NAME: "Abhicash",
    COMPANY_NAME_CAPS: "ABHICASH",
    COMPANY_NAME_SMALLCASE: "abhicash",
    BASE_URL: 'https://backend.abhicash.in/',
    FRONTEND_BASE_URL: 'https://admin.abhicash.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ac',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.abhicash.in/',
    TITLE: "Instant Loans and Financial Wellness Solutions",
    FAVICON: AbhicashFavicon,
    LOGO: AbhicashLogo,
    LIGHT_LOGO: AbhicashLogo,
     HEADER_LOGO_WIDTH: "80px",
    RootcssClassName: "Abhicash-css",
    BOSS_EMAILID: "mohit.bansal@abhicash.in",
    NBFC_NAME_TO_SHOW: "CNMP",
    REPORT_DB_KEY: "abhicash",
    ADMIN_URL_STRING_SHORT :"abhicash.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.abhicash.in",
     NBFC_SHORT:"CNMP",
     WEBSITE_URL:"https://abhicash.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : CNMP Investments Private Limited',
      BANK_NAME: 'Bank : HDFC, Delhi',
      BRANCH_NAME: 'Branch : CONNAUGHT PLACE',
      ACCOUNT_NUMBER: 'A/C : 50200072791180',
      IFSC_CODE: 'ifsc code : HDFC0001563',
      NBFC_NAME:"CNMP Investments Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.abhicash.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      // MOBILE_NO: "08047861605",
      MOBILE_NO: "9999966040",
      EMAIL_ID: "recovery@abhicash.in",
      FINANCE_MAIL_ID: "finance@abhicash.in",
      SUPPORT_MAIL_ID: "support@abhicash.in",
      KYC_URL: 'https://admin.abhicash.in/kyc/',
      CONFIG_MAIL_ID: "config@abhicash.in",
      RECOVERY_MAIL_ID:"recovery@abhicash.in",
      APP_LINK:"app.abhicash.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Abhicash Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  },
  'admin.creditjar.in': {
    COMPANY_NAME: "Creditjar",
    COMPANY_NAME_CAPS: "CREDITJAR",
    COMPANY_NAME_SMALLCASE: "creditjar",
    BASE_URL: 'https://backend.creditjar.in/',
    FRONTEND_BASE_URL: 'https://admin.creditjar.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cj',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.creditjar.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: creditjarFavicon,
    LOGO: creditJarLogoDark,
    LIGHT_LOGO: creditJarLogoDark,
     HEADER_LOGO_WIDTH: "100px",
    RootcssClassName: "Creditjar-css",
    BOSS_EMAILID: "mohit.bansal@creditjar.in",
    NBFC_NAME_TO_SHOW: "D.S. Integrated",
    REPORT_DB_KEY: "creditjar",
    ADMIN_URL_STRING_SHORT :"creditjar.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.creditjar.in",
     NBFC_SHORT:"D.S. Integrated",
     WEBSITE_URL:"https://creditjar.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : D.S.INTEGRATED FINSEC PRIVATE LIMITED ',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : RAJKOT - GONDAL ROAD',
      ACCOUNT_NUMBER: 'A/C : 072805003919',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME:"D.S. Integrated Finsec Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.creditjar.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      MOBILE_NO: "9876543219",
      EMAIL_ID: "recovery@Creditjar.in",
      FINANCE_MAIL_ID: "finance@Creditjar.in",
      SUPPORT_MAIL_ID: "support@Creditjar.in",
      KYC_URL: 'https://admin.creditjar.in/kyc/',
      CONFIG_MAIL_ID: "config@Creditjar.in",
      RECOVERY_MAIL_ID:"recovery@Creditjar.in",
      APP_LINK:"app.Creditjar.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"D.S. Integrated Finsec Private Limited",
      ADDRESS:"OPP ANDH MAHILA VIKAS GRUH, ARIHANT,SHRAMJIVI SOCIETY,",
      AREA:" DHEBAR ROAD, RAJKOT,",
      CITY :"Rajkot, Gujarat, 360002"
    }

  },
  'admin.cashbridge.in': {
    COMPANY_NAME: "Cashbridge",
    COMPANY_NAME_CAPS: "CASHBRIDGE",
    COMPANY_NAME_SMALLCASE: "cashbridge",
    BASE_URL: 'https://backend.cashbridge.in/',
    FRONTEND_BASE_URL: 'https://admin.cashbridge.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cb',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.cashbridge.in/',
    TITLE: "Get quick, hassle-free funds Designed to meet urgent needs",
    FAVICON: cashbridgeFavicon2,
    LOGO: cashbridgeLogoWhite,
    LIGHT_LOGO: cashbridgeLogoWhite,
     HEADER_LOGO_WIDTH: "120px",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@cashbridge.in",
    NBFC_NAME_TO_SHOW: "Rachit Capital Services",
    REPORT_DB_KEY: "cashbridge",
    ADMIN_URL_STRING_SHORT :"cashbridge.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.cashbridge.in",
     NBFC_SHORT:"Rachit Capital Services",
     WEBSITE_URL:"https://cashbridge.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Rachit Capital Services Private limited',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : GURGAON - SECTOR 14',
      ACCOUNT_NUMBER: 'A/C : 002105030854',
      IFSC_CODE: 'ifsc code : ICIC0000021',
      NBFC_NAME:"Rachit Capital Services Privated Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.cashbridge.in/uploadDocuments/",
      // MOBILE_NO: "+91-9220320064",
      // MOBILE_NO: "9876543219",
      MOBILE_NO: "9217938488",
      EMAIL_ID: "recovery@cashbridge.in",
      FINANCE_MAIL_ID: "finance@cashbridge.in",
      SUPPORT_MAIL_ID: "support@cashbridge.in",
      KYC_URL: 'https://admin.cashbridge.in/kyc/',
      CONFIG_MAIL_ID: "config@cashbridge.in",
      RECOVERY_MAIL_ID:"recovery@cashbridge.in",
      APP_LINK:"app.cashbridge.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Rachit Capital Services Privated Limited",
      ADDRESS:"Vipul Plaza, ",
      AREA:"Sector 81,",
      CITY :"Faridabad, Haryana - 121002"
    }

  },
  'frontend.cashtap.in': {
    COMPANY_NAME: "Payday",
    COMPANY_NAME_CAPS: "PAYDAY",
    COMPANY_NAME_SMALLCASE: "payday",
    BASE_URL: 'https://backend.cashtap.in/',
    FRONTEND_BASE_URL: 'https://frontend.cashtap.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ct',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://frontend.cashtap.in/',
    TITLE: "Empowering seamless, secure, and compliant digital lending for the next generation of financial institutions.",
    FAVICON: cashtapFavIcon,
    LOGO: CashtapLogo,
    LIGHT_LOGO: CashtapLogo,
     MSITE_URL: "https://msite.cashtap.in/",
     HEADER_LOGO_WIDTH: "120px",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@payday.in",
    NBFC_NAME_TO_SHOW: "D S Integrated FinSec Pvt. Ltd",
    REPORT_DB_KEY: "payday",
    ADMIN_URL_STRING_SHORT :"cashtap.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"frontend.cashtap.in",
     NBFC_SHORT:"D S Integrated FinSec Pvt. Ltd",
     WEBSITE_URL:"https://cashtap.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : D.S. INTEGRATED FINSEC PRIVATE LIMITED',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : RAJKOT - GONDAL ROAD',
      ACCOUNT_NUMBER: 'A/C : 777705220265',
      IFSC_CODE: 'ifsc code : ICIC0000728',
      NBFC_NAME:"D S Integrated FinSec Pvt. Ltd.",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://frontend.cashtap.in/uploadDocuments/",
      MOBILE_NO: "9876543219",
      EMAIL_ID: "recovery@payday.in",
      FINANCE_MAIL_ID: "finance@payday.in",
      SUPPORT_MAIL_ID: "support@payday.in",
      KYC_URL: 'https://frontend.cashtap.in/kyc/',
      CONFIG_MAIL_ID: "config@payday.in",
      RECOVERY_MAIL_ID:"recovery@payday.in",
      APP_LINK:"app.payday.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"D.S. Integrated Finsec Private Limited",
      ADDRESS:"OPP ANDH MAHILA VIKAS GRUH, ARIHANT,SHRAMJIVI SOCIETY,",
      AREA:" DHEBAR ROAD, RAJKOT,",
      CITY :"Rajkot, Gujarat, 360002"
    }

  },
  'larkfrontend.cashtap.in': {
    // COMPANY_NAME: "EQUATRUS TECHNOLOGIES PRIVATE LIMITED",
    COMPANY_NAME: "Lark",
    COMPANY_NAME_CAPS: "LARK",
    COMPANY_NAME_SMALLCASE: "lark",
    BASE_URL: 'https://larkbackend.cashtap.in/',
    FRONTEND_BASE_URL: 'https://larkfrontend.cashtap.in/',
    LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ctl',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://larkfrontend.cashtap.in/',
    TITLE: "Small Loans Big Impact",
    FAVICON: LarkFavIcon,
    LOGO: larklogo,
    LIGHT_LOGO: larklogo,
     MSITE_URL: "https://msitelark.cashtap.in/",
     HEADER_LOGO_WIDTH: "60px",
    RootcssClassName: "Cashbridge-css",
    BOSS_EMAILID: "mohit.bansal@cashtaplark.in",
    NBFC_NAME_TO_SHOW: "LARK TRADING & FINANCE LIMITED",
    REPORT_DB_KEY: "cashtaplark",
    ADMIN_URL_STRING_SHORT :"larkfrontend.cashtap.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"larkfrontend.cashtap.in",
     NBFC_SHORT:"lark trading & finance limited",
     WEBSITE_URL:"https://cashtap.in/",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : EQUATRUS TECHNOLOGIES PRIVATE LIMITED',
      BANK_NAME: 'Bank : IDFC bank limited',
      BRANCH_NAME: 'Branch : sector 50 noida',
      ACCOUNT_NUMBER: 'A/C : 10283311338',
      IFSC_CODE: 'ifsc code : IDFB0020145',
      NBFC_NAME:"LARK TRADING & FINANCE LIMITED",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://larkfrontend.cashtap.in/uploadDocuments/",
      MOBILE_NO: "9876543210",
      EMAIL_ID: "it.developer@cashtap.in",
      FINANCE_MAIL_ID: "finance@cashtap.in",
      SUPPORT_MAIL_ID: "support@cashtap.in",
      KYC_URL: 'https://larkfrontend.cashtap.in/kyc/',
      CONFIG_MAIL_ID: "config@cashtap.in",
      RECOVERY_MAIL_ID:"recovery@cashtap.in",
      APP_LINK:"",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"EQUATRUS TECHNOLOGIES PRIVATE LIMITED",
      ADDRESS:"C-273, SECTOR-63, NOIDA, Gautam Buddha Nagar, Uttar Pradesh, 201301",
      AREA:"Gautam Buddha Nagar",
      CITY :"NOIDA"
    }

  },
};


const TENANT_URLS={
  cf:{
    frontend:'https://admin.credfin.money/',
    backend:'https://backend.credfin.money/',
  },
  ac:{
    frontend:'https://admin.abhicash.in/',
    backend:'https://backend.abhicash.in/',
  },
  cj:{
    frontend:'https://admin.creditjar.in/',
    backend:'https://backend.creditjar.in/',
  },
  cb:{
    frontend:'https://admin.cashbridge.in/',
    backend:'https://backend.cashbridge.in/',
  },
  ct:{
    frontend:'https://frontend.cashtap.in/',
    backend:'https://backend.cashtap.in/',
  },
  ctl:{
    frontend:'https://larkfrontend.cashtap.in/',
    backend:'https://larkbackend.cashtap.in/',
  },
}

const handleURL = () => {
  const link = window.location?.host;
  // const link = "admin.credfin.money";
  // const link = "admin.micromoney.in";
  // const link = "adminu.micromoney.in";
  // const link = "admin.abhicash.in";
  // const link = "admin.creditjar.in";
  // const link = "admin.cashbridge.in";
  // const link = "frontend.cashtap.in";
  // const link = "larkfrontend.cashtap.in";
  return link
}

const InvalidTenantPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center', margin: '10% 15px' }}>
    <h1>Invalid URL</h1>
    <p>This domain is not configured for access. Please Contact the Developer</p>
  </div>
);

export const Company_DATA = {
  CREDFIN: "Credfin",
  MICROMONEY: "Micromoney",
  ABHICASH: "Abhicash",
  CREDITJAR: "Creditjar",
  CASHBRIDGE: "Cashbridge",
  PAYDAY: "Payday",
  LARK: "Lark",
}

export const CheckFunction = () => {
  const url = handleURL();
  const tenantConfig = TENANT_CONFIGS[url]
  if (!tenantConfig) {
    return ""
  } 
  return tenantConfig
}


const MainFunction = () => {
  const dispatch = useDispatch()
  
  const url = handleURL();

  const tenantConfig = TENANT_CONFIGS[url]

  if (!tenantConfig) {

    return <InvalidTenantPage />;
  }

  dispatch({ type: 'SET_ACTIVE_TENANT', payload: tenantConfig });
  document.title = tenantConfig.TITLE || "";

  const rootElement = document.getElementById('phocketApp');
  if (rootElement) {
    rootElement.classList.add(tenantConfig?.RootcssClassName);
  }


  const favicon = document.querySelector('link[rel="shortcut icon"]') ||
    document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = tenantConfig.FAVICON || "";
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }


  return <Outlet />;

}

export default MainFunction;

export const CREDFIN_LIKE = [Company_DATA?.CREDFIN]
export const MICROMONEY_LIKE = [Company_DATA?.MICROMONEY]
export const ABHICASH_ONLY = [Company_DATA?.ABHICASH]
export const ABHICASH_LIKE = [Company_DATA?.ABHICASH,Company_DATA?.CREDITJAR,Company_DATA?.CASHBRIDGE]
export const CREDITJAR_LIKE = [Company_DATA?.CREDITJAR]
export const CASHBRIDGE_LIKE = [Company_DATA?.CASHBRIDGE, Company_DATA?.PAYDAY]
export const CASHBRIDGE_ONLY = [Company_DATA?.CASHBRIDGE]
export const PAYDAY_LIKE = [Company_DATA?.PAYDAY, Company_DATA?.LARK]
export const PAYDAY_ONLY = [Company_DATA?.PAYDAY]
export const LARK_LIKE = [Company_DATA?.LARK]


export const CHECK_COMPANY_TENANT = (arr)=>{
    const tenant = CheckFunction();
    if(arr?.includes(tenant?.COMPANY_NAME)){
      return true
    }
    return false
}

export const TENANT_BASED_URL = (tenantId,urlType)=>{
  if(TENANT_URLS && TENANT_URLS?.[tenantId]){
    if(urlType != ""){
      return TENANT_URLS?.[tenantId]?.[urlType]
    }else{
      return TENANT_URLS?.[tenantId]
    }
  }else{
    return false
  }
}